import { baseUrl, csrfToken } from './http.js';

let validityInterval = null;

// Resolve from the running Alpine, not 'alpinejs': the admin bundle boots the
// copy bundled inside Livewire, and a second instance has no basket store.
const basketStore = () => window.Alpine.store('basket');

// An open checkout in another tab listens, and checks its basket hasn't changed under it.
function announceChange() {
    if (typeof BroadcastChannel !== 'undefined') {
        const channel = new BroadcastChannel('gifted-basket');
        channel.postMessage('changed');
        channel.close();
    }
}

function updateStore(data) {
    const store = basketStore();

    store.count = data.count;
    store.currency = data.currency || '';
    store.errors = data.errors || [];
    store.items = data.items;
    store.itemsGA4 = data.itemsGA4 || [];
    store.lastItem = data.lastItem || null;
    store.reward = data.reward;
    store.total = parseFloat(data.total) || 0;
    store.totalFormatted = data.totalFormatted;
    store.validUntil = data.validUntil;
}

function startValidityCountdown() {
    if (validityInterval) {
        clearInterval(validityInterval);
    }

    validityInterval = setInterval(() => {
        const store = basketStore();

        if (!store.validUntil) {
            store.validity = '00:00';
            return;
        }

        const diff = new Date(store.validUntil).getTime() - Date.now();

        if (diff > 0) {
            const minutes = Math.floor(diff / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            store.validity = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        } else {
            store.validity = '00:00';
            list();
        }
    }, 1000);
}

export async function list() {
    const response = await fetch(`${baseUrl()}basket`, {
        credentials: 'include',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    const data = await response.json();

    updateStore(data);

    return data;
}

export async function add(voucherId, optionId, quantity = 1, eventSessionId = null) {
    const response = await fetch(`${baseUrl()}basket/add`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
            event_session_id: eventSessionId,
            option_id: optionId || null,
            quantity: quantity,
            voucher_id: voucherId,
        }),
    });

    const data = await response.json();

    if (response.ok) {
        updateStore(data);
        announceChange();
        data.request = { option_id: optionId, voucher_id: voucherId };
    }

    return { data, ok: response.ok };
}

export async function update(rowId, quantity) {
    const response = await fetch(`${baseUrl()}basket/update`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
            quantity: quantity,
            row_id: rowId,
        }),
    });

    const data = await response.json();

    if (response.ok) {
        updateStore(data);
        announceChange();
    }

    return { data, ok: response.ok };
}

export async function remove(rowId) {
    return update(rowId, 0);
}

export async function addReward() {
    const response = await fetch(`${baseUrl()}reward/add`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    const data = await response.json();

    if (response.ok) {
        updateStore(data);
        announceChange();
    }

    return { data, ok: response.ok };
}

export async function removeReward() {
    const response = await fetch(`${baseUrl()}reward/remove`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    const data = await response.json();

    if (response.ok) {
        updateStore(data);
        announceChange();
    }

    return { data, ok: response.ok };
}

export function startHeartbeat() {
    list().then(() => {
        startValidityCountdown();
    });
}
